import React ,{useEffect, useState} from 'react'
import {Button, Col, Input, Row, Card, Form, message, Tooltip, Typography} from "antd";
import cookie from "react-cookies"
import {getHostAddress,getFrontEndAddress} from "../Tool/UtileFun"
import {LoginOutlined,LockTwoTone,UserOutlined,LockOutlined,InfoCircleOutlined} from '@ant-design/icons'
import img2 from "../User/IMG/7.png";

export function AdminLogin(){

    const mainPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/class"
    }

    const { Title } = Typography;
    const username = "username"
    const role = "role"
    const roleTest = "admin"
    const userId = "userId"
    const [realRole,setRealRole] = useState()

    const getAdmin=(data)=>{
        fetch(
            "http://"+getHostAddress()+"/roles/getAdmin",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({userId:data.id,role:data.role}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setRealRole(data)
                console.log("roles表")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    let user
    const [userData,setUserData] = useState();
    const login=(data)=>{
        fetch(
            "http://"+getHostAddress()+"/user/adminLogin",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(data),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
               if (data === null || data === undefined || data === "" || data === "{}" || data.id === null){
                  message.error("用户名或密码错误")
               } else if(data.id !== null && data.name === name && data.role === "admin"){

                   message.success("登录成功");
                   console.log("loginInfo")
                   console.log(data)
                   //let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000);//一天
                   //cookie.save(username,data.name,{ expires: inFifteenMinutes })
                   //cookie.save(role,data.role,{ expires: inFifteenMinutes })

                   cookie.remove(username)
                   cookie.remove(role)
                   cookie.remove(roleTest)
                   cookie.remove(userId)

                   cookie.save(username,data.name)
                   cookie.save(role,data.role)
                   cookie.save(roleTest,roleTest)
                   cookie.save(userId,data.id)


                   console.log(cookie.load(username))
                   console.log(cookie.load(role))
                   mainPage()
               }else {
                    message.warn("未知错误")
               }
               console.log(data)
            })
            .catch(error => message.error("error"+error));
    }


    const loginConnection = ()=>{

        if (name === "" || name === null || name === undefined){
            message.error("id不得为空")
        }

        if (password === "" || password === null || password === undefined){
            message.error("密码不得为空")
        }

        let jsonData = {
            name:name,
            password:password
        }
        login(jsonData)
    }


    let name
    const idOnChange = e =>{
        console.log(e.target.value)
        name = e.target.value
    }

    let password
    const pwdOnchange = e =>{
        console.log(e.target.value)
        password = e.target.value
    }

    let sectionStyle = {
        width: "100%",
        height: "100%",
        // makesure here is String确保这里是一个字符串，以下是es6写法
        backgroundImage: `url(${img2})`,
        backgroundSize: "cover",
    };

    const layout =(
        <>
            <div style={{height:"121px"}}></div>
            <div style={sectionStyle}>
                <div ></div>
                <Row gutter={[24,24]} >
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={14}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={7}>
                        <Card style={{height:340,width:439}}>
                            <Row gutter={[10,10]}>
                                <Col span={9}></Col>
                                <Title level={3}>管理员登录</Title>
                            </Row>
                            <Row gutter={[10,10]}>
                                <Input size="large"
                                       placeholder="用户名"
                                       prefix={<UserOutlined style={{color:"#1890FF"}} />}
                                       onChange={idOnChange}
                                       suffix={
                                           <Tooltip title="此账号用于登录">
                                               <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                           </Tooltip>
                                       }
                                >

                                </Input>
                            </Row>
                            <br/>
                            <Row gutter={[1,1]}>
                                <Input size="large"
                                       placeholder="密码"
                                       prefix={<LockTwoTone twoToneColor="#1890FF" />}
                                       type={"password"}
                                       onChange={pwdOnchange}
                                       suffix={
                                           <Tooltip title="输入您的密码,注意大小写">
                                               <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                           </Tooltip>
                                       }
                                >

                                </Input>
                            </Row>
                            <br/>
                            {/*<Row gutter={[1,1]}>*/}
                            {/*    <Input size="large"*/}
                            {/*           placeholder="注册码"*/}
                            {/*           prefix={<LockTwoTone twoToneColor="#1890FF" />}*/}
                            {/*           onChange={pwdOnchange}*/}
                            {/*           suffix={*/}
                            {/*               <Tooltip title="注册码">*/}
                            {/*                   <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />*/}
                            {/*               </Tooltip>*/}
                            {/*           }*/}
                            {/*    >*/}

                            {/*    </Input>*/}
                            {/*</Row>*/}
                            {/*<br/>*/}
                            <Row>
                                <Col span={10}>

                                </Col>
                                <Col>
                                    <Button icon={<LoginOutlined />} type="primary" onClick={loginConnection}>登录</Button><br/>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                    <Col span={23}>
                        {/*<Card>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Input ></Input>*/}
                        {/*    <Button type="primary">login</Button>*/}
                        {/*</Card>*/}
                    </Col>
                </Row>
            </div>
        </>
    )

    let borSty = {
        //border:"1px solid #ccc"
    }

    return(
        <>
            <Row>
                <Col style={borSty} span={8}>&nbsp;</Col>
                <Col style={borSty} span={8} offset={8}>&nbsp;</Col>
            </Row>
            <Row>
                <Col style={borSty} span={6} offset={6}>
                    &nbsp;
                </Col>
                <Col style={borSty} span={6} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>

            {/*100%*/}
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col style={borSty} span={12} offset={6}>
                    &nbsp;
                </Col>
            </Row>
            {/*100%*/}

            <Row>
                <Col style={borSty} span={7} offset={13}>
                    <div className="login">
                        <Card style={{
                            // height:200,
                            width:450,
                            //margin:"230px 0 0 810px"
                        }}>
                            <Row>
                                <Col style={borSty} span={12} offset={8}>
                                    <Title level={4}>用户登录</Title>
                                </Col>
                            </Row>
                            <Form>
                                <Form.Item>
                                    <Input //style={sty}
                                        size="large"
                                        placeholder="用户名"
                                        onChange={idOnChange}
                                    >
                                    </Input>
                                </Form.Item>
                                <Form.Item>
                                    <Input //style={sty}
                                        size="large"
                                        placeholder="密码"
                                        type={"password"}
                                        onChange={pwdOnchange}
                                    >
                                    </Input>
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        type="primary" block
                                        onClick={loginConnection}
                                    >登录</Button><br/>
                                </Form.Item>
                                {/*<input type="text" name="u" placeholder="用户名" required="required"/>*/}
                                {/*<input type="password" name="p" placeholder="密码" required="required"/>*/}
                                {/*<button type="submit" className="btn btn-primary btn-block btn-large">登录</button>*/}
                            </Form>
                        </Card>
                    </div>
                </Col>
            </Row>
        </>
    )
}
